import CourseModel, { CourseModelDetailed } from "./courseModel"

export default class CourseService {
  constructor(api) {
    this.api = api
  }

  async getCourses(query) {
    try {
      let res = await this.api.getCoursesBy(query)
      return res.map(course => new CourseModel(course))
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCoursesDetailed(query) {
    try {
      let res = await this.api.courseListDetailed(query)
      return res.map(course => new CourseModelDetailed(course))
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCoursesBy(location) {
    try {
      return await this.getCourses({city: location})
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCoursesDetailedBy(location) {
    try {
      return await this.getCoursesDetailed({city: location})
    } catch (error) {
      return Promise.reject(error)
    }
  }
}